import { useCallback, useState, type FunctionComponent } from 'react'
import { InternalLink } from '../../const/Links'
import { VISIBLE_PRODUCTLINE_CARDS_AMOUNT } from '../../const/digitContants'
import type { ProductLineResult } from '../../data/ProductLineFragment'
import { ProductLineCard } from '../product/ProductLineCard'
import { Hidden } from './Hidden'
import style from './ProductLineCardGroup.module.sass'
import { ShowMoreLessButton } from './ShowMoreLessButton'
import { TitleEnumeration } from './TitleEnumeration'

type ProductLineCardGroupProps = {
	productLines: ProductLineResult[]
	title: string
}

export const ProductLineCardGroup: FunctionComponent<ProductLineCardGroupProps> = ({ productLines, title }) => {
	const [isButtonMoreVisible, setIsButtonMoreVisible] = useState(true)

	const visibleProductLines = isButtonMoreVisible
		? productLines?.slice(0, VISIBLE_PRODUCTLINE_CARDS_AMOUNT)
		: productLines

	const exceededCardLimit = productLines && productLines.length > VISIBLE_PRODUCTLINE_CARDS_AMOUNT

	const toggleButton = useCallback(() => setIsButtonMoreVisible((prev) => !prev), [])

	return (
		<div className={style.productLinesWrapper} id="anchorProductLines">
			<TitleEnumeration title={title} sum={productLines.length} />
			<Hidden breakpoint="mobileDown">
				<div className={style.productLineGroup}>
					{productLines &&
						productLines.length > 0 &&
						productLines.map((line) => (
							<ProductLineCard
								key={line.id}
								name={`${line.brand?.name} ${line.name} (${line.paginateProducts?.pageInfo.totalCount})`}
								url={`${InternalLink.ProductLine}${line.slug}`}
								isDisabled={line.paginateProducts?.pageInfo.totalCount === 0}
								imageUrl={line.products[0]?.image?.url ?? '/images/placeholder-product.png'}
							/>
						))}
				</div>
			</Hidden>
			<Hidden breakpoint="mobileUp">
				<div className={style.productLineGroup}>
					{visibleProductLines &&
						visibleProductLines.length > 0 &&
						visibleProductLines.map((line) => (
							<ProductLineCard
								key={line.id}
								name={`${line.brand?.name} ${line.name} (${line.paginateProducts?.pageInfo.totalCount})`}
								url={`${InternalLink.ProductLine}${line.slug}`}
								isDisabled={line.paginateProducts?.pageInfo.totalCount === 0}
								imageUrl={line.products[0]?.image?.url ?? '/images/placeholder-product.png'}
							/>
						))}
				</div>

				<div className={style.buttonWrapper}>
					{exceededCardLimit && (
						<ShowMoreLessButton
							anchorId="anchorProductLines"
							moreIsVisible={isButtonMoreVisible}
							onClick={toggleButton}
						/>
					)}
				</div>
			</Hidden>
		</div>
	)
}
